
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skiutleie",
      function () {
        return require("private-next-pages/[region]/[resort]/skiutleie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skiutleie"])
      });
    }
  